var _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulldog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.996 30.373C89.9752 30.6607 89.8755 30.9371 89.7079 31.1719C87.9145 33.5269 86.1211 35.8811 84.6117 38.4341C83.894 39.5379 82.8899 42.074 82.3847 43.3243C79.8848 34.5938 75.7058 26.2101 68.916 20.047C69.9298 20.1001 71.5172 20.002 72.4642 19.7863C74.5296 19.5941 76.7695 19.3993 78.7351 20.1299C82.191 22.4578 85.6432 24.7911 89.0916 27.1297C89.9412 27.9198 90.0233 29.2731 89.996 30.373Z",
    fill: "#422311"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0848 20.047C24.2941 26.2141 20.12 34.5922 17.6161 43.3243C17.1149 42.0281 16.1019 39.5685 15.3891 38.434C13.8797 35.8811 12.0863 33.5261 10.2929 31.1719C10.1253 30.9371 10.0256 30.6607 10.0048 30.373C9.97505 29.2739 10.0611 27.919 10.9092 27.1273C14.356 24.786 17.8082 22.4527 21.2657 20.1275C23.2321 19.3969 25.4704 19.5924 27.5366 19.7839C28.4916 20.0036 30.075 20.1001 31.0848 20.047Z",
    fill: "#422311"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.482 46.508C82.0524 50.6966 80.9058 54.8346 78.9193 58.5228C75.9271 50.1463 71.6258 40.7826 63.7595 37.829L57.248 35.2407L50.035 34.8231H49.9698L42.7568 35.2407L36.2413 37.829C28.3798 40.773 24.0672 50.1543 21.0855 58.5228C18.7916 53.9246 17.0087 48.5379 17.6193 43.3243C19.7821 35.4394 23.4397 28.3591 28.848 22.1985C29.7612 21.1525 30.6921 20.0977 32.006 19.5514C37.5077 17.0065 44.2694 13.9805 49.9103 17.8336C49.9693 17.8176 50.0315 17.8176 50.0905 17.8336C56.0379 13.8325 63.2309 17.2302 68.9176 20.047C74.8981 25.1424 82.8441 38.6006 82.482 46.508Z",
    fill: "#F0D274"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9194 58.5228C75.9271 50.1463 71.6259 40.7826 63.7595 37.829L57.248 35.2407L50.035 34.8231H49.9698L42.7568 35.2407L36.2413 37.829C28.375 40.7617 24.0713 50.1648 21.0855 58.5228C19.7772 66.7536 23.0873 76.0135 28.5359 82.228C28.7606 82.4705 29.0412 82.6542 29.3533 82.7631C32.8017 84.0826 36.2582 83.8211 39.767 83.0415C41.3037 83.7077 42.9137 83.8814 44.5663 83.8123C45.8617 84.089 47.0782 84.7287 48.4492 84.7238C50.6497 84.8614 52.9283 84.8172 54.9663 83.8847C56.75 83.7471 58.5531 83.8541 60.233 83.0415C63.741 83.8179 67.2007 84.0834 70.6475 82.7631C76.5861 77.9445 80.3362 65.9796 78.9194 58.5228ZM44.5108 40.1784C44.9026 39.7447 45.3153 39.3279 45.7659 38.8516C46.1143 38.4413 48.808 37.6166 49.9666 37.6102C51.1252 37.6037 53.868 38.4324 54.2309 38.8516C54.6847 39.3279 55.0942 39.7447 55.486 40.1784C55.7773 40.4712 55.5922 40.8639 55.486 41.1897C54.3741 43.5858 54.2703 41.2372 53.0039 40.7319C52.2178 40.32 51.3263 40.9813 51.6965 41.8439C51.9024 42.2976 51.9499 42.8826 51.443 43.1537C50.7591 43.5214 50.0921 44.0959 50.0181 44.9181C50.0181 44.8747 50.0036 44.8329 49.998 44.7902C49.9924 44.8329 49.9803 44.8747 49.9779 44.9181C49.8435 43.1408 47.548 43.5013 48.2995 41.8439C48.6688 40.9821 47.7782 40.3152 46.9921 40.7319C46.3927 40.995 46.058 41.5188 45.7353 42.0498C45.1303 42.922 43.9693 40.5911 44.5108 40.1752V40.1784ZM66.2537 66.0246C66.1121 71.5481 64.416 76.9323 60.6538 81.0896C59.9643 81.9746 59.0189 82.3447 57.9537 82.4968C56.6808 82.504 51.8566 83.3818 50.0213 83.3979C48.1901 83.3979 43.3111 82.5281 42.0471 82.4968C40.9819 82.3447 40.0357 81.9722 39.347 81.0896C35.5856 76.9307 33.8887 71.5489 33.7471 66.0246C33.7471 62.2914 34.2339 56.4566 36.4875 53.4451C40.1306 50.267 45.3282 48.6345 49.9698 48.6023C54.6364 48.6192 59.8525 50.2581 63.5133 53.4451C65.7661 56.4453 66.2553 62.3019 66.2537 66.0246Z",
    fill: "#EE964D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6525 40.5638C55.5634 41.1479 55.3011 41.6919 54.8995 42.1255C54.2357 42.7112 53.9235 40.9821 53.0063 40.7287C51.9354 40.2516 51.2949 41.2179 51.8083 42.1681C52.1937 43.3862 50.1114 43.3146 50.0205 44.9149C50.0157 44.8715 50.0092 44.8288 50.0004 44.787C49.9915 44.8288 49.9851 44.8715 49.9803 44.9149C49.9062 44.0918 49.2392 43.5182 48.5554 43.1505C48.0485 42.8785 48.0967 42.2952 48.3019 41.8406C48.6712 40.9789 47.7806 40.3119 46.9945 40.7287C46.0732 40.9846 45.7691 42.7104 45.1013 42.1255C44.7922 41.7897 44.5636 41.388 44.4327 40.9508C44.3522 40.6877 44.2814 40.3988 44.5132 40.1752C44.905 39.7415 45.3177 39.3247 45.7683 38.8484C46.1167 38.4381 48.8104 37.6134 49.969 37.6069C51.1405 37.5908 53.8704 38.4292 54.2333 38.8484C54.6951 39.4398 55.4924 39.9016 55.6525 40.5638Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_702_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2537 66.0246C66.1121 71.5481 64.416 76.9323 60.6538 81.0896C59.9643 81.9746 59.0189 82.3447 57.9537 82.4968C56.6808 82.504 51.8566 83.3818 50.0213 83.3979C48.1901 83.3979 43.3112 82.5281 42.0472 82.4968C40.9819 82.3447 40.0357 81.9722 39.347 81.0896C35.5856 76.9307 33.8887 71.5489 33.7471 66.0246C33.7471 62.2914 34.2339 56.4566 36.4875 53.4451C40.1307 50.267 45.3282 48.6345 49.9698 48.6023C54.6364 48.6192 59.8525 50.2581 63.5133 53.4451C65.7661 56.4453 66.2553 62.3019 66.2537 66.0246Z",
    fill: "#C18A54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_702_51",
    x: 64.916,
    y: 19.6097,
    width: 29.0842,
    height: 31.7145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_702_51",
    x: 6.00002,
    y: 19.6076,
    width: 29.0848,
    height: 31.7166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_702_51",
    x: 13.4983,
    y: 15.9997,
    width: 72.9957,
    height: 50.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_702_51",
    x: 16.8,
    y: 34.8231,
    width: 66.4189,
    height: 57.9588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_702_51",
    x: 40.3558,
    y: 37.6067,
    width: 19.2967,
    height: 15.3082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_702_51",
    x: 29.7471,
    y: 48.6023,
    width: 40.5066,
    height: 42.7956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_702_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_702_51",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulldog);
export default __webpack_public_path__ + "static/media/Bulldog.436d1e86499ab01ee94fc0c8eb041750.svg";
export { ForwardRef as ReactComponent };